__turbopack_context__.v({
  "bottomContainer": "style-module-scss-module__SHaMJG__bottomContainer",
  "breadcrumbs": "style-module-scss-module__SHaMJG__breadcrumbs",
  "breadcrumbsWrap": "style-module-scss-module__SHaMJG__breadcrumbsWrap",
  "content": "style-module-scss-module__SHaMJG__content",
  "scale": "style-module-scss-module__SHaMJG__scale",
  "soundActive": "style-module-scss-module__SHaMJG__soundActive",
  "soundBtn": "style-module-scss-module__SHaMJG__soundBtn",
  "soundBtnLabel": "style-module-scss-module__SHaMJG__soundBtnLabel",
  "soundWave": "style-module-scss-module__SHaMJG__soundWave",
  "title": "style-module-scss-module__SHaMJG__title",
  "video": "style-module-scss-module__SHaMJG__video",
  "wrapper": "style-module-scss-module__SHaMJG__wrapper",
});
